export default __webpack_public_path__ + "static/media/black-logo.4692a5c3.png";